import { Image, merge, Spinner, Stack, Text } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import React, { useMemo } from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { ResponsiveSize, useResponsiveSize } from '../../../contexts/responsiveContext';
import More from '../../More';
import Vignette from '../../Vignette';
import * as DOMPurify from 'dompurify';

const Actualite = (props) => {

    // CONTEXTS
    const { responsiveSize } = useResponsiveSize();

    // PROPS
    const {
        datePublication = [],
        description = undefined,
        images = [],
        nomCommercial = undefined,
        titre = undefined,
        vignetteSrc = undefined
    } = props;

    // STATES
    const [isExpanded, { toggle }] = useBoolean(false);

    // MEMOS
    const styles = useMemo(
        () => {
            let styles = {
                content: {
                    WebkitBoxOrient: isExpanded ? "unset" : "vertical",
                    WebkitLineClamp: isExpanded ? "unset" : "2",
                    display: isExpanded ? "inline" : "-webkit-box",
                    fontSize: 14,
                    lineHeight: "20px",
                    marginBottom: 6,
                    overflow: "hidden"
                },
                date: {
                    root: {
                        color: "grey",
                        fontSize: 11,
                    }
                },
                header: {
                    root: {
                        padding: 13,
                        paddingBottom: 27,
                    }
                },
                infos: {
                    root: {
                        gap: 16,
                        paddingBottom: 15,
                    }
                },
                operation: {
                    root: {
                        fontSize: 12,
                        fontWeight: 700,
                        lineHeight: "14px",
                    }
                },
                outer: {
                    root: {
                        background: "white",
                        border: "1px solid #DADADA",
                        borderRadius: 13,
                        marginBottom: 18,
                        paddingBottom: 30,
                    }
                },
                spinner: {
                    root: {
                        backgroundColor: "#D9D9D9",
                        height: 375,
                    }
                },
                title: {
                    root: {
                        fontSize: 14,
                        fontWeight: 700,
                        lineHeight: "20px",
                        paddingBottom: 15,
                        textTransform: "uppercase",
                    }
                },
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(styles, {
                    outer: {
                        root: {
                            marginBottom: 18,
                            marginLeft: 26,
                            marginRight: 26,
                            paddingBottom: 39,
                        }
                    },
                });

            return styles;
        },
        [isExpanded, responsiveSize]
    );

    // RENDER
    return <Stack styles={styles.outer}>
        <Stack styles={styles.header}>
            <Stack horizontal verticalAlign="center" styles={styles.infos}>
                <Vignette src={vignetteSrc} />
                <Stack>
                    {<Text styles={styles.operation}>{nomCommercial || "Information générale"}</Text>}
                    {!!datePublication && <Text styles={styles.date}>{new Date(datePublication).toLocaleString("fr-FR", { year: "numeric", month: "long", day: "2-digit" })}</Text>}
                </Stack>
            </Stack>
            <Text styles={styles.title}>{titre}</Text>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }} style={styles.content} /> {/* dangerouslySetInnerHTML ok à condition d'utiliser un sanitizer */}
            <More label={isExpanded ? "voir moins" : "voir plus"} onClick={toggle} />
        </Stack>
        {Array.isArray(images) && images.length > 0 &&
            <Carousel showStatus={false} showThumbs={false}>
                {images.map((image, index) => {
                    const { fileData } = image;
                    if (!!fileData) {
                        const src = `data:image/png;base64,${fileData}`;
                        return <Image key={index} src={src} />;
                    }
                    else return <Spinner key={index} styles={styles.spinner} />
                })}
            </Carousel>
        }
    </Stack>;

};

export default Actualite;